/* tslint:disable */
/* eslint-disable */
/* @relayHash 4a76de9784b16439070643c337db08e9 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Page = {
    offset?: number | null;
    limit?: number | null;
};
export type MachineReportFilter = {
    machineUUID?: string | null;
    machineReportTypeUUID?: string | null;
    searchText?: string | null;
    sent?: boolean | null;
};
export type App_MachineReports_QueryVariables = {
    page?: Page | null;
    filter?: MachineReportFilter | null;
};
export type App_MachineReports_QueryResponse = {
    readonly machineReports: {
        readonly " $fragmentRefs": FragmentRefs<"MachineReports_machineReports">;
    } | null;
};
export type App_MachineReports_Query = {
    readonly response: App_MachineReports_QueryResponse;
    readonly variables: App_MachineReports_QueryVariables;
};



/*
query App_MachineReports_Query(
  $page: Page
  $filter: MachineReportFilter
) {
  machineReports(page: $page, filter: $filter) {
    ...MachineReports_machineReports
  }
}

fragment MachineReports_machineReports on MachineReportPage {
  edges {
    uuid
    machine {
      name
    }
    title
    reportDate
    previewURL
  }
  pageInfo {
    total
    given
    offset
    limit
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Page",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "MachineReportFilter",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_MachineReports_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "machineReports",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "MachineReportPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "MachineReports_machineReports",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_MachineReports_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "machineReports",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "MachineReportPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MachineReport",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "uuid",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "machine",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Machine",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "name",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "reportDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "previewURL",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_MachineReports_Query",
            "id": null,
            "text": "query App_MachineReports_Query(\n  $page: Page\n  $filter: MachineReportFilter\n) {\n  machineReports(page: $page, filter: $filter) {\n    ...MachineReports_machineReports\n  }\n}\n\nfragment MachineReports_machineReports on MachineReportPage {\n  edges {\n    uuid\n    machine {\n      name\n    }\n    title\n    reportDate\n    previewURL\n  }\n  pageInfo {\n    total\n    given\n    offset\n    limit\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cd55d9617c3c64df1c9e6f12b9edf79b';
export default node;
